import { HandbagCondition, HandbagPurchaseCondition } from './constants';
import typeHints from './typeHints';

const attributes = {

  handbag_brand: {
    friendly: 'Brand',
    validations: {
      maxLength: 255,
    },
  },

  handbag_collection: {
    friendly: 'Collection',
    validations: {
      maxLength: 255,
    },
  },

  handbag_model: {
    friendly: 'Model',
    validations: {
      maxLength: 255,
    },
  },

  handbag_color: {
    friendly: 'Color',
    validations: {
      maxLength: 255,
    },
  },

  handbag_material: {
    friendly: 'Material',
    validations: {
      maxLength: 255,
    },
  },

  handbag_hardware: {
    friendly: 'Hardware',
    validations: {
      maxLength: 255,
    },
  },

  handbag_size: {
    friendly: 'Size',
    validations: {
      maxLength: 255,
    },
  },

  handbag_style: {
    friendly: 'Style',
    validations: {
      maxLength: 255,
    },
  },

  handbag_year_produced: {
    friendly: 'Year Produced',
    validations: {
      type: 'integer',
      mustBePositive: true,
    },
  },

  handbag_country_of_origin: {
    friendly: 'Country',
    validations: {
      maxLength: 255,
    },
  },

  handbag_msrp: {
    friendly: 'MSRP',
    validations: {
      type: 'decimal',
    },
    typeHint: typeHints.Monetary,
  },

  handbag_condition: {
    friendly: 'Condition',
    validations: {
      type: 'enum',
      enumType: HandbagCondition,
    },
  },

  handbag_purchase_condition: {
    friendly: 'Purchase Condition',
    validations: {
      type: 'enum',
      enumType: HandbagPurchaseCondition,
    },
  },

  handbag_type: {
    friendly: 'Type',
    validations: {
      maxLength: 255,
    },
  },

  handbag_dimensions: {
    friendly: 'Dimensions',
    validations: {
      maxLength: 255,
    },
  },

};

export default attributes;

export const HandbagDefaultSplitAttribute = 'handbag_type';

export const HandbagItemSearchAttributes = [];

export const HandbagOverviewAttributes = ['title', 'handbag_type', 'handbag_brand', 'handbag_collection', 'handbag_model', 'handbag_year_produced',
  'handbag_country_of_origin', 'handbag_condition', 'rarity', 'market_value', 'quantity', 'inventory_no', 'tags'];

export const HandbagSpecificationAttributes = ['handbag_color', 'handbag_material', 'handbag_hardware', 'handbag_size', 'handbag_dimensions', 'handbag_msrp'];

export const HandbagPurchaseAttributes = ['purchase_date', 'purchase_price', 'handbag_purchase_condition', 'purchase_contact', 'purchase_notes'];

export const HandbagDetailAttributes = [];

export const HandbagRequiredAttributes = [];

export const HandbagDisplayAttributes = ['handbag_type', 'handbag_brand', 'handbag_collection', 'handbag_model', 'handbag_color', 'handbag_material', 'tags'];

export const HandbagSliderGalleryAttributes = {
  titleKey: 'handbag_brand',
  subtitleKey: 'handbag_collection',
};



// WEBPACK FOOTER //
// ./src/config/handbagDataAttributes.js